const de = {
    general: {
        app_name: "Tracky",
        dashboard: "Übersicht",
        entries: "Einträge",
        media: "Medien",
        other: "Andere",
        dark_mode: "Dunkle Ansicht",
        settings: "Einstellungen",
        general: "Generell",
        edit: "Bearbeiten",
        save: "Speichern",
        delete: "Löschen",
        close: "Schliessen",
        search: "Suche",
        new: "Neu",
        time: "Zeit",
        location: "Lokalitäten",
        activities: "Aktivitäten",
        no_date_defined: "Kein Datum definiert",
        day_of_week: {
            monday: "Montag",
            tuesday: "Dienstag",
            wednesday: "Mittwoch",
            thursday: "Donnerstag",
            friday: "Freitag",
            saturday: "Samstag",
            sunday: "Sonntag"
        },
        time_of_day: {
            morning: "Morgen",
            afternoon: "Nachmittags",
            evening: "Abend",
            night: "Nacht",
            workout: "Workout"
        },
        month: {
            january: "Januar",
            february: "Februar",
            march: "März",
            april: "April",
            may: "Mai",
            june: "Juni",
            july: "Juli",
            august: "August",
            september: "September",
            october: "Oktober",
            november: "November",
            december: "Dezember"
        }
    },
    today: {
        notification: {
            entry_saved: "Der Eintrag wurde gespeichert."
        },
        header: "Täglich",
        add: "Hinzufügen",
        title: "Titel",
        text: "Text",
        save: "Speichern",
        mood: "Stimmung",
        entry: "Eintrag",
        edit: "Bearbeiten",
        select_date: "Datum auswählen",
        total_locations_at_this_point: "Anzahl Punkte"
    },
    mood_card: {
        notification: {
            mood_saved: "Die Stimmung wurde gespeichert."
        },
        mood: "Stimmung"
    },
    location_card: {
        header: "Standorte",
        open_location_points: "Öffne Standortpunkte"
    },
    sessioncard: {
        delete: "Löschen",
        device_name: "Gerätename",
        device_os: "Betriebssystem",
        started: "Gestartet"
    },
    settings: {
        header: "Einstellungen",
        language: "Sprache",
        change_password: "Passwort ändern",
        current_password: "Aktuelles Passwort",
        new_password: "Neues Passwort",
        repeat_new_password: "Neues Passwort wiederholen",
        change: "ändern",
        profile: "Profil",
        sign_out: "Ausloggen",
        devices: "Geräte",
        devices_description: "Hier findest du alle Geräte, welche mit deinem Konto verknüpft sind.",
        export_my_data: "Exportiere meine Daten"
    },
    register: {
        email: "E-Mail",
        password: "Passwort",
        repeat_password: "Passwort wiederholen",
        register: "Registrieren",
        or_want_to_login: "oder einloggen?"
    },
    login: {
        login: "Login",
        email: "E-Mail",
        password: "Passwort",
        register_now: "Registrieren?",
        forgot_password: "Passwort vergessen?"
    },
    forgot_password: {
        header: "Passwort vergessen?",
        header_description: "Gebe unten deine E-Mail Adresse ein. Danach werden wir dir einen Link schicken, wo du dein Passwort zurücksetzen kannst.",
        email: "E-Mail",
        request_password: "Passwort anfordern",
        or_want_to_login: "Einloggen?"
    },
    reset_password: {
        notification: {
            new_password_has_been_set: "Das neue Passwort wurde gesetzt.",
            passwords_do_not_match: "Die Passwörter stimmen nicht überein."
        },
        header: "Passwort zurücksetzen",
        header_description: "Du kannst hier dein neues Passwort definieren, welches dann ab sofort aktiv ist.",
        new_password: "Neues Passwort",
        repeat_new_password: "Neues Passwort wiederholen",
        reset: "Zurücksetzen"
    },
    activate: {
        notification: {
            user_activated: "Der Benutzer wurde aktiviert."
        }
    },

    timeline: {
        header: "Zeitachse",
        no_data_recorded_for_this_date_yet: "Es wurden noch keine Daten aufgezeichnet für diesen Tag.",
        install_the_companion: "Installiere die Companion App um deine Zeitachse zu sehen.",
        or: "Oder",
        try_import_snapplace: "Probiere einen Import aus SnapPlace",
        you_can_import_this_day_tomorrow: "Du kannst diesen Tag erst morgen importieren.",
        on_the_way: "Unterwegs",
        no_data_recorded_for_this_month_yet: "Noch keine Daten für diesen Monat aufgezeichnet.",
        no_data_recorded_for_this_year_yet: "Noch keine Daten für dieses Jahr aufgezeichnet.",
        most_visited_cities: "Meistbesuchte Städte",
        most_visited_countries: "Meistbesuchte Länder",
        unknown_city: "Unbekannte Stadt",
        unknown_country: "Unbekanntes Land",
        visits_recorded: "Besuche aufgezeichnet",
        yearly_view: "Jahresansicht",
        monthly_view: "Monatsansicht",
        daily_view: "Tagesansicht",
        select_month: "Monat auswählen",
        select_year: "Jahr auswählen",
        show_range: "Anzeigen",
        year: "Jahr",
        do_you_really_want_to_delete_this_day: "Möchtest du diesen Tag wirklich löschen?",
        do_you_really_want_to_delete_this_point: "Möchtest du diesen Punkt wirklich löschen?",
        do_you_really_want_to_retrieve_missing_addresses: "Möchtest du die fehlenden Adressen wirklich abrufen? Dies kann eine Weile dauern.",
        delete_this_day: "Diesen Tag löschen",
        retrieve_missing_addresses: "Fehlende Adressen abrufen",
        switch_to_group_view: "Zur Gruppenansicht wechseln",
        switch_to_point_view: "Zur Punktansicht wechseln",
        enter_edit_mode: "Bearbeitungsmodus aktivieren",
        exit_edit_mode: "Bearbeitungsmodus beenden",
        edit_location: "Standort bearbeiten",
        address: "Adresse",
        search_location: "Standort suchen",
        e_g: "z.B. {location}",
        from: "Von",
        to: "Bis",
        any: "Beliebig",
        clear_dates: "Daten löschen",
        apply_filters: "Suchen",
        no_locations_found: "Keine Standorte für diese Suchanfrage gefunden.",
        no_locations_hint: "Passe deine Suchfilter an oder versuche es mit einem anderen Begriff.",
        reset_search: "Suche zurücksetzen",
        insights_for: "Einblicke für",
        memory_year_ago: "Heute vor 1 Jahr",
        memory_years_ago: "Heute vor {years} Jahren",
        random_memory: "Eine zufällige Erinnerung aus deiner Zeitachse",
        you_were_here_on: "Du warst hier am",
        you_were_here_from: "Du warst hier vom",
        you_visited_here_across: "Du hast diesen Ort besucht über",
        different_periods: "verschiedene Zeiträume:",
        points: "Punkte",
        total: "Insgesamt",
        recorded_points: "Punkte erfasst",
        results: "Ergebnisse",
        switch_to_list_view: "Zur Listenansicht wechseln",
        switch_to_aggregated_view: "Zur aggregierten Ansicht wechseln",
        show_heatmap: "Heatmap anzeigen",
        hide_heatmap: "Heatmap verbergen",
        total_distance: "Gesamtdistanz",
        points_recorded: "Aufgezeichnete Punkte",
        cities_visited: "Besuchte Städte",
        countries_visited: "Besuchte Länder",
        places_visited: "Besuchte Orte",
        more_cities: "weitere",
        km: "km",
        search_fields: {
            city: "Stadt",
            address: "Ganze Adresse",
            country: "Land"
        },
        notification: {
            day_deleted: "Die Tages-Zeitachse wurde gelöscht.",
            error_deleting_point: "Fehler beim Löschen des Punktes.",
            error_fetching_locations: "Fehler beim Abrufen der zu löschenden Orte.",
            point_deleted: "Punkt gelöscht.",
            error_updating_location: "Fehler beim Aktualisieren des Standorts.",
            location_updated: "Standort aktualisiert.",
            enter_address_to_search: "Bitte geben Sie eine Adresse zur Suche ein.",
            error_fetching_search_results: "Fehler beim Abrufen der Suchergebnisse.",
            no_missing_addresses_found: "Es wurden keine Punkte mit fehlenden Adressen gefunden.",
            retrieving_addresses: "Adressen werden abgerufen...",
            addresses_retrieved: "Adressen abgerufen."
        }
    },

    tracks: {
        header: "Routen",
        distance: "Distanz",
        import: "Import",
        name: "Name",
        elevation: "Höhe",
        meters_above_sea: "Meter über Meer",
        bpm: "BPM",
        heartRate: "Herzfrequenz",
        duration: "Dauer",
        date: "Datum",
        time: "Zeit",
        edit: "Bearbeiten",
        type: "Typ",
        search: "Nach Tracks suchen...",
        notification: {
            track_has_been_imported: "Der Track wurde erfolgreich importiert.",
            file_not_supported: "Die Datei wird nicht unterstützt.",
            track_has_been_saved: "Der Track wurde gespeichert.",
            track_has_been_deleted: "Der Track wurde gelöscht."
        },
        types: {
            driving: "Auto fahren",
            walking: "Gehen",
            running: "Joggen",
            hiking: "Wandern",
            biking: "Velo fahren",
            sailing: "Segeln",
            boating: "Mit Boot",
            skiing: "Ski fahren",
            snowboarding: "Snowboarden",
            sledding: "Schlitteln"
        },
        heartRateAvg: "Durchschnitt Herzfrequenz",
        uphill: "Höhe hoch",
        downhill: "Höhe runter",
        min_distance: "Minimale Distanz",
        max_distance: "Maximale Distanz",
        speed: "Geschwindigkeit",
        power: "Leistung",
        cadence: "Trittfrequenz",
        averageSpeed: "Durchschnittliche Geschwindigkeit",
        maxElevation: "Maximale Höhe",
        minElevation: "Minimale Höhe",
        maxHeartRate: "Maximale Herzfrequenz"
    },

    fitness: {
        header: "Fitness",
        import_range: "Bereich importieren...",
        import_date_range_title: "Datumsbereich importieren",
        importing_progress: "Importiere {current} von {total} ({date})...",
        import_failed: "Import fehlgeschlagen am {date}. Bitte stellen Sie sicher, dass Sie authentifiziert sind, indem Sie zuerst einen einzelnen Tag synchronisieren.",
        import_success: "Erfolgreich Daten für {count} Tag(e) importiert.",
        steps: "Schritte",
        calories: "Kalorien",
        floors: "Etagen",
        distance: "Distanz",
        resting_heart_rate: "Durchschnittliche Herzfrequenz",
        sleep_effective: "Effektive Schlafdauer (ohne Wachphasen)",
        sleep_total: "Totale Schlafdauer",
        import_data: "Import von Services",
        weight: "Gewicht",
        body_fat: "Körperfett",
        muscle_mass: "Muskelmasse",
        bone_mass: "Knochenmasse",
        hydration: "Wasseranteil",
        spo2: "SpO2",
        body_temperature: "Körpertemperatur",

        no_data_here: "Hier sind keine Daten für dieses Datum.",
        stats: "Übersicht",

        all_time: "Gesamt",
        all_time_steps: "Schritte (Gesamt)",
        all_time_average_steps: "Schritte pro Tag (Durchschnitt)",
        all_time_distance: "Distanz (Gesamt)",

        history_insights: "Historische Einblicke",
        dynamic_insights: "Dynamische Einblicke",
        time_range: "Zeitraum",
        group_by: "Gruppieren nach",
        metric: "Metrik",
        
        last_30_days: "Letzte 30 Tage",
        last_3_months: "Letzte 3 Monate",
        last_6_months: "Letzte 6 Monate",
        last_year: "Letztes Jahr",
        
        by_day: "Nach Tag",
        by_month: "Nach Monat",
        by_year: "Nach Jahr",
        
        average_sleep: "Durchschnittlicher Schlaf",

        insight_most_active_day_title: "Aktivster Tag",
        insight_most_active_day_text: "Du hast deinen Höchststand am {date} mit {steps} Schritten erreicht.",
        insight_distance_milestone_title: "Distanz-Meilenstein",
        insight_distance_milestone_text: "Du hast in diesem Zeitraum {distance} km zurückgelegt! Das sind etwa {marathons} Marathons.",
        insight_best_sleep_title: "Beste Nachtruhe",
        insight_best_sleep_text: "Deine beste Nachtruhe war am {date} mit {sleep}.",
        insight_peak_climbing_title: "Höchster Aufstieg",
        insight_peak_climbing_text: "Du hast am {date} {floors} Etagen erklommen.",
        insight_active_streak_title: "Längste aktive Strähne",
        insight_active_streak_text: "Deine längste Strähne von 10k+ Schritten beträgt {streak} Tage am Stück!",
        insight_calorie_burner_title: "Ultimativer Kalorienverbrauch",
        insight_calorie_burner_text: "Du hast am {date} unglaubliche {calories} Kalorien verbrannt.",
        
        insight_total_steps_title: "Schritt-Meister",
        insight_total_steps_text: "Du bist in diesem Zeitraum unglaubliche {steps} Schritte gegangen.",
        insight_avg_steps_title: "Täglicher Durchschnitt",
        insight_avg_steps_text: "Du gehst durchschnittlich {steps} Schritte am Tag.",
        insight_rest_day_title: "Erholungstag",
        insight_rest_day_text: "Dein ruhigster Tag war am {date} mit nur {steps} Schritten. Eine wohlverdiente Pause!",
        insight_sleep_consistency_title: "Schlafroutine",
        insight_sleep_consistency_text: "Du hast in {days} Nächten über 7 Stunden geschlafen!",
        insight_weekend_warrior_title: "Wochenend-Krieger",
        insight_weekend_warrior_text: "Du hast das Wochenende am {date} mit {steps} Schritten gerockt.",
        insight_lowest_hr_title: "Zen-Meister",
        insight_lowest_hr_text: "Dein niedrigster Ruhepuls war {hr} bpm am {date}.",
        insight_bounce_back_title: "Das Comeback",
        insight_bounce_back_text: "Nachdem du dich am {restDate} ausgeruht hast, bist du am {date} mit {steps} Schritten zurückgekehrt.",
        insight_max_distance_title: "Distanz-Dämon",
        insight_max_distance_text: "Dein längster Marsch war am {date} mit {distance} km.",
        insight_min_sleep_title: "Nachteule",
        insight_min_sleep_text: "Du bist am {date} mit nur {sleep} Schlaf ausgekommen.",
        insight_goal_crusher_title: "Ziel-Zerstörer",
        insight_goal_crusher_text: "Du hast an {days} verschiedenen Tagen das 10.000-Schritte-Ziel erreicht!",
        kpi_card_title: "Fitness-Insights",
        kpi_card_avg_steps: "Ø Schritte (Letzte 7 Tage)",
        insight_weight_journey_title: "Gewichtsreise",
        insight_weight_journey_lost_text: "Du hast in diesem Zeitraum {diff} kg abgenommen!",
        insight_weight_journey_gained_text: "Du hast in diesem Zeitraum {diff} kg zugenommen.",
        insight_lowest_body_fat_title: "Schlanke Maschine",
        insight_lowest_body_fat_text: "Dein niedrigster Körperfettanteil lag am {date} bei {body_fat}%.",
        insight_peak_muscle_mass_title: "Muskel-Höhepunkt",
        insight_peak_muscle_mass_text: "Deine Muskelmasse erreichte am {date} den Höhepunkt von {muscle} kg!"
    },

    movies: {
        notification: {
            saved_personal_experience: "Die persönliche Erfahrung wurde gespeichert.",
            personal_experience_deleted: "Die persönliche Erfahrung wurde gelöscht."
        },
        do_you_really_want_to_delete: "Möchtest du diese Erfahrung wirklich löschen?",
        header: "Filme",
        back: "zurück",
        runtime: "Laufzeit",
        minutes: "Minuten",
        search_for_movies: "Nach Filmen suchen...",
        have_you_watched_this_movie: "Hast du diesen Film gesehen?",
        watched_where: "Wo gesehen?",
        watched_where_cinema: "Kino",
        watched_where_streamed: "Stream/VOD (Netflix, Disney+, ...)",
        watched_where_tv: "TV (Free-TV Premiere, ...)",
        watched_where_both: "Im Kino und im Stream / TV",
        month: "Monat",
        year: "Jahr",
        rating: "Bewertung",
        watched_when: "Wann geschaut?",
        personal_experience: "Persönliche Erfahrung",
        library: "Bibliothek"
    },

    tvshows: {
        notification: {
            saved_personal_experience: "Die persönliche Erfahrung wurde gespeichert.",
            personal_experience_deleted: "Die persönliche Erfahrung wurde gelöscht."
        },
        do_you_really_want_to_delete: "Möchtest du diese Erfahrung wirklich löschen?",
        header: "Serien",
        library: "Bibliothek",
        search_for_tvshows: "Nach Serien suchen...",
        seasons: "Staffeln",
        back: "Zurück",
        have_you_watched_this_show: "Hast du diese Serie gesehen?",
        rating: "Bewertung",
        watched_when: "Wann hast du die erste Episode geschaut?",
        month: "Monat",
        year: "Jahr",
        personal_experience: "Persönliche Erfahrung"
    },

    drinks: {
        header: "Drinks",
        base_alcohol: "Hauptalkohol",
        ingredients: "Zutaten",
        type: "Art",
        rating: "Bewertung"
    },
    recipes: {
        header: "Rezepte",
        type: "Art",
        ingredients: "Zutaten",
        process: "Ablauf",
        duration: "Dauer"
    },
    elements: {
        add: "Hinzufügen",
        select_file: "Datei auswählen...",
        image: "Bild",
        upload: "Hochladen",
        url: "URL",
        select: "Auswählen",
        selected: "Datei ausgewählt"
    },
    fitness_workouts: {
        header: "Fitness Workouts",
        add_workout: "Workout starten",
        workout_name: "Workout Name",
        activities: "Aktivitäten",
        add_activity: "Aktivität hinzufügen",
        add_set: "Satz hinzufügen",
        exercise_name: "Übungsname",
        no_activities: "Noch keine Aktivitäten hinzugefügt.",
        name: "Name",
        sets: "Sätze",
        amount: "Wiederholungen",
        weight: "Gewicht",
        date: "Datum",
        saving: "Speichert...",
        saved: "Entwurf gespeichert",
        finish_workout: "Workout beenden",
        draft: "Entwurf",
        duration_min: "Dauer (min)",
        distance: "Distanz",
        calories: "Kalorien",
        locked_during_session: "Das Datum ist während einer aktiven Sitzung gesperrt",
        strength: "Kraft",
        cardio: "Ausdauer",
        search_workouts: "Workouts suchen",
        filter_all: "Alle",
        workouts_this_month: "Workouts dieser Monat",
        duration_this_month: "Dauer dieser Monat",
        activities_this_month: "Aktivitäten dieser Monat",
        vs_last_month: "vs. letzter Monat",
        more_insights: "Mehr Einblicke",
        distance_this_month: "Distanz dieser Monat",
        calories_this_month: "Kalorien dieser Monat",
        weight_lifted_this_month: "Gewicht gehoben dieser Monat",
        sets_this_month: "Sätze dieser Monat",
        timeframe_day: "Tag",
        timeframe_week: "Woche",
        timeframe_month: "Monat",
        kpi_workouts: "Workouts",
        kpi_duration: "Dauer",
        kpi_activities: "Aktivitäten",
        kpi_distance: "Distanz",
        kpi_calories: "Kalorien",
        kpi_weight_lifted: "Gewicht",
        kpi_sets: "Sätze",
        vs_yesterday: "vs. gestern",
        vs_last_week: "vs. letzte Woche"
    },
    exercises: {
        bench_press: "Bankdrücken",
        incline_bench_press: "Schrägbankdrücken",
        dumbbell_press: "Kurzhanteldrücken",
        squats: "Kniebeugen",
        deadlift: "Kreuzheben",
        leg_press: "Beinpresse",
        leg_extension: "Beinstrecker",
        leg_curl: "Beinbeuger",
        calf_raises: "Wadenheben",
        overhead_press: "Schulterdrücken",
        lateral_raises: "Seitheben",
        pull_ups: "Klimmzüge",
        lat_pulldown: "Latzug",
        barbell_row: "Langhantelrudern",
        seated_cable_row: "Kabelrudern",
        push_ups: "Liegestütze",
        bicep_curls: "Bizepscurls",
        hammer_curls: "Hammercurls",
        tricep_extensions: "Trizepsstrecken",
        tricep_dips: "Trizeps-Dips",
        lunges: "Ausfallschritte",
        bulgarian_split_squats: "Bulgarian Split Squats",
        hip_thrust: "Hip Thrusts",
        crunches: "Crunches",
        leg_raises: "Beinheben",
        shoulder_press_machine: "Schulterpresse",
        rear_delt_fly: "Reverse Butterfly",
        butterfly_machine: "Butterfly",
        chest_press_machine: "Brustpresse",
        cable_crossover: "Kabelzug",
        smith_machine_squats: "Multipresse Kniebeugen",
        smith_machine_bench_press: "Multipresse Bankdrücken",
        ab_crunch_machine: "Bauchpresse",
        kettlebell_swings: "Kettlebell Swings",
        farmers_walk: "Farmer's Walk",
        front_squats: "Frontkniebeugen",
        good_mornings: "Good Mornings",
        face_pulls: "Face Pulls",
        t_bar_rows: "T-Bar Rudern",
        preacher_curls: "Preacher Curls",
        skull_crushers: "Skull Crushers",
        barbell_shrugs: "Langhantel Shrugs",
        dumbbell_shrugs: "Kurzhantel Shrugs",
        box_jumps: "Box Jumps",
        romanian_deadlift: "Rumänisches Kreuzheben",
        hack_squats: "Hackenschmidt Kniebeugen",
        glute_kickbacks: "Glute Kickbacks",
        side_plank: "Seitstütz",
        russian_twists: "Russian Twists",
        running: "Laufen",
        treadmill: "Laufband",
        cycling: "Radfahren",
        indoor_cycling: "Indoor Cycling",
        elliptical: "Crosstrainer",
        rowing: "Rudern",
        stairmaster: "Treppensteiger",
        walking: "Gehen",
        plank: "Unterarmstütz",
        jump_rope: "Seilspringen",
        hip_abduction: "Abduktoren",
        hip_adduction: "Adduktoren",
        seated_calf_raises: "Wadenheben sitzend"
    },
    source: "Quelle"
};

export default de;